import PropTypes from 'prop-types'

import { Box } from '@material-ui/core'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { TableRowGovernanceProject } from './components'

const GovernanceProjectsTable = ({ governanceProjects, refresh }) => {
  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: true, useBothWheelAxes: true }}
      >
        <Table emptyMessage="Nenhum projeto de governança encontrado" noWrap>
          <TableHead>
            <TableRow>
              <TableCell width="5%">ID</TableCell>
              <TableCell width="15%" align="left">
                Nome
              </TableCell>
              <TableCell width="20%" align="left">
                Empresa
              </TableCell>
              <TableCell width="15%" align="left">
                Etapa atual
              </TableCell>
              <TableCell width="35%" align="left">
                Importação
              </TableCell>
              <TableCell width="10%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {governanceProjects?.map((project) => (
              <TableRowGovernanceProject
                key={project?.id}
                governanceProject={project}
                refresh={refresh}
              />
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

GovernanceProjectsTable.propTypes = {
  governanceProjects: PropTypes.array,
  refresh: PropTypes.func,
}

GovernanceProjectsTable.defaultProps = {
  governanceProjects: [],
  refresh: () => {},
}

export default GovernanceProjectsTable
